/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberAppointmentsId200, GetApiBarberAppointmentsId400, GetApiBarberAppointmentsId401, GetApiBarberAppointmentsId403, GetApiBarberAppointmentsId404, GetApiBarberAppointmentsId500, GetApiBarberAppointmentsIdPathParams, GetApiBarberAppointmentsIdQueryResponse } from "../entities/GetApiBarberAppointmentsId";
import { modelsBarberAppointmentOutputSchema } from "./models/barberAppointmentOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const getApiBarberAppointmentsIdPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<GetApiBarberAppointmentsIdPathParams>

/**
 * @description OK
 */
export const getApiBarberAppointmentsId200Schema = z.lazy(() => modelsBarberAppointmentOutputSchema) as unknown as z.ZodType<GetApiBarberAppointmentsId200>

/**
 * @description Bad Request
 */
export const getApiBarberAppointmentsId400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberAppointmentsId400>

/**
 * @description Unauthorized
 */
export const getApiBarberAppointmentsId401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberAppointmentsId401>

/**
 * @description Forbidden
 */
export const getApiBarberAppointmentsId403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberAppointmentsId403>

/**
 * @description Not Found
 */
export const getApiBarberAppointmentsId404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberAppointmentsId404>

/**
 * @description Internal Server Error
 */
export const getApiBarberAppointmentsId500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberAppointmentsId500>

export const getApiBarberAppointmentsIdQueryResponseSchema = z.lazy(() => getApiBarberAppointmentsId200Schema) as unknown as z.ZodType<GetApiBarberAppointmentsIdQueryResponse>